export default __webpack_public_path__ + "images/product.jpg?126b7453d75ecfefc2ef115dbaa518db";